import { Box, styled, Tooltip } from '@mui/material';
import { theme } from 'redesign';
import { SidebarItemDescription } from './common-sidebar-section.types';
import { StyledSidebarNotificationBox } from './styled-sidebar-notification-box';
import { WrapMeWhen } from '../common/wrap-me-when';

export const SidebarSectionBaseItem = ({
  icon,
  label,
  isSidebarOpen,
  notificationCount,
  ...boxProps
}: SidebarItemDescription & { isSidebarOpen: boolean }) => {
  return (
    <WrapMeWhen
      when={!isSidebarOpen}
      wrapper={(children) => (
        <Tooltip placement="right" title={label}>
          {children}
        </Tooltip>
      )}
    >
      <SidebarSectionBaseBox {...boxProps}>
        <IconBox>{icon}</IconBox>
        {isSidebarOpen ? (
          <LabelBox>
            <Box>{label}</Box>
            {notificationCount ? (
              <StyledSidebarNotificationBox data-testid="notification-box">
                {notificationCount}
              </StyledSidebarNotificationBox>
            ) : null}
          </LabelBox>
        ) : null}
      </SidebarSectionBaseBox>
    </WrapMeWhen>
  );
};

export const StyledSidebarItem = styled(SidebarSectionBaseItem, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{
  isActive?: boolean;
}>(({ theme, isActive }) => ({
  backgroundColor: 'unset',
  color: theme.palette.lwPrimaryAccentDark[60],
  border: 'none',
  cursor: 'pointer',
  height: '40px',
  marginBottom: theme.spacing(2),
  width: '100%',
  borderRadius: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  textAlign: 'left',

  '& svg': {
    color: theme.palette.lwPrimaryAccentDark[60],
  },

  ...(isActive && {
    backgroundColor: theme.palette.lwPrimaryAccentLight[10],
    color: theme.palette.lwPrimaryAccentLight[100],
    fontVariationSettings: '"wght" 600',

    '& svg': {
      color: theme.palette.lwPrimaryAccentLight[100],
    },

    '&:hover': {
      backgroundColor: 'transparent',
    },
  }),
}));

const SidebarSectionBaseBox = styled(Box)({
  component: 'span',
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
});

const LabelBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

const IconBox = styled(Box)({
  marginRight: theme.spacing(1),
});
